import { State } from '@progress/kendo-data-query';
import { toODataString } from '@progress/kendo-data-query/dist/npm/odata.operators';
import { CategoryManager } from 'src/types/categoryManager';
import { ODataResponse } from 'src/types/oDataResponse';
import { User } from 'src/types/user';
import { Vendor } from 'src/types/vendor';
import { get } from './Api';
import { IShowTotalsReport } from 'src/types/IShowTotalsReport';
import { VendorUser } from 'src/types/vendorUser';
import type { VendorPortalSettingsResponse } from 'src/types/vendorPortalSettings';

async function getVendors(filter: State): Promise<ODataResponse<Vendor>> {
  return get<ODataResponse<Vendor>>(`/odata/vendor?${toODataString(filter, { utcDates: false })}`);
}

async function getUsers(filter: State): Promise<ODataResponse<VendorUser>> {
  return get<ODataResponse<VendorUser>>(`/odata/vendorUser?${toODataString(filter, { utcDates: false })}`);
}

async function getVendorByNumber(vendorNumber: string | number): Promise<ODataResponse<Vendor>> {
  let venNum: string = vendorNumber.toString();

  let filter = {
    take: 1,
    filter: {
      logic: 'or',
      value: '',
      filters: [{ field: 'numberString', operator: 'eq', value: venNum }],
    },
  } as State;

  return get<ODataResponse<Vendor>>(`/odata/vendor?${toODataString(filter, { utcDates: false })}`);
}

async function getUsersByVendorNumber(vendorNumber: string | number): Promise<User[]> {
  return get<User[]>(`/UserAdmin/getUsersByVendNo?vendNo=${encodeURIComponent(vendorNumber)}`);
}

async function getAllItemCategoryNames(): Promise<string[]> {
  return get<string[]>('/Pim/GetAllCategoryNames');
}

async function getCategoryManagers(vendorNumber: string | number): Promise<CategoryManager[]> {
  return get<CategoryManager[]>(`/VendorPortal/getCategoryManagers?vendNo=${encodeURIComponent(vendorNumber)}`);
}

async function getDoesVendorHavePrograms(vendorNumber: string | number): Promise<boolean> {
  return get<boolean>(`/VendorPortal/getDoesVendorHavePrograms?vendNo=${encodeURIComponent(vendorNumber)}`);
}

async function getVendorPortalSettings(vendorNumber: string | number): Promise<VendorPortalSettingsResponse> {
  const vend = encodeURIComponent(String(vendorNumber));
  return get<VendorPortalSettingsResponse>(`/VendorSettings/${vend}/settings`);
}

async function getVendorShowTotals(vendorNumber: number, year: number): Promise<IShowTotalsReport[]> {
  return get<IShowTotalsReport[]>(`/Reports/GetShowTotalsReport?vendorNumber=${vendorNumber}&year=${year}`);
}

export default {
  getVendors,
  getUsers,
  getVendorByNumber,
  getUsersByVendorNumber,
  getAllItemCategoryNames,
  getCategoryManagers,
  getVendorShowTotals,
  getDoesVendorHavePrograms,
  getVendorPortalSettings,
};
